"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var DropdownImage = function DropdownImage(_ref) {
  var image = _ref.image;
  return (0, _preact.h)("div", {
    className: "dropdown-image"
  }, (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(image)
  }));
};

var _default = DropdownImage;
exports.default = _default;